import { render, staticRenderFns } from "./TakeAwayMenuCartPanel.vue?vue&type=template&id=3fbe01a8&"
import script from "./TakeAwayMenuCartPanel.vue?vue&type=script&lang=ts&"
export * from "./TakeAwayMenuCartPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports